import React from "react"
import { Outlet, useNavigate } from "react-router-dom"

import { CurrentUser, CurrentOrg, CurrentOrgId } from "../lib/store"
import { AUTH_ORGANIZATION_ID } from "../lib/api"

function CurrentOrganization() {
  const navigate = useNavigate()
  const [currentUser] = CurrentUser.useState()
  const [org, setOrg] = CurrentOrg.useState()
  const [orgId, setOrgId] = CurrentOrgId.useState()
  console.log("Render CurrentOrganization")
  console.log("CurrentOrganization", { currentUser, org, orgId })

  React.useEffect(() => {
    // Logout sets CurrentUser to {} — empty object is still truthy; require identity fields.
    if (!currentUser?.email && !currentUser?.username) {
      return
    }

    const orgs = currentUser.organizations
    // Wait until /users/self has resolved organizations (do not treat undefined like [])
    if (!Array.isArray(orgs)) {
      return
    }

    if (orgs.length === 0) {
      console.log("No organizations — redirecting to create flow")
      navigate("/organizations/create", { replace: true })
      return
    }

    if (!orgId) {
      let sessionOrgId = sessionStorage.getItem(AUTH_ORGANIZATION_ID)
      if (sessionOrgId) {
        const sessionMatch = orgs.find((o) => o.id === sessionOrgId)
        if (sessionMatch) {
          setOrgId(sessionOrgId)
          return
        }
        sessionStorage.removeItem(AUTH_ORGANIZATION_ID)
      }

      const firstId = orgs[0].id
      sessionStorage.setItem(AUTH_ORGANIZATION_ID, firstId)
      setOrgId(firstId)
      return
    }

    const matching = orgs.find((o) => o.id === orgId)
    if (!matching) {
      console.log("Session org not in user org list — resetting to first org")
      const firstId = orgs[0].id
      sessionStorage.setItem(AUTH_ORGANIZATION_ID, firstId)
      setOrgId(firstId)
      return
    }

    setOrg(matching)
  }, [currentUser, orgId, setOrg, setOrgId, navigate])

  if ((!currentUser?.email && !currentUser?.username) || !org) return <></>
  return <Outlet />
}

export default CurrentOrganization
